module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--CH-900f51a5637d611e83b92849e9447e06.jpg";